import axios from "axios";
import { mysphereAPIURL } from "../app/auth/util/CustomConstants";
import { getAccessToken } from "./helpers.js";

// const accessToken = await getAccessToken();

export const getLoggedInUser = async () => {
  console.log("Fetching logged-in user details");
  const accessToken = await getAccessToken();
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${accessToken}`,

  };
  return await axios.get(`${mysphereAPIURL}/api/v1/user/me`, { headers });
};

export const googleLogin = async (data) => {
  const accessToken = await getAccessToken();
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${accessToken}`,
    "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
  };

  return await axios.post(
    `${mysphereAPIURL}/api/v1/user/login/google`,
    data,
    { headers }
  );
};

export const googleCodeTokenExchange = async (data) => {
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios.post(
    `${mysphereAPIURL}/api/v1/user/code/google/exchange`,
    data,
    { headers }
  );
};

export const googleLogout = async () => {
  const accessToken = await getAccessToken();
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${accessToken}`,
  };

  return await axios.get(
    `${mysphereAPIURL}/api/v1/user/logout/google`,
    { headers }
  );
};